
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative pt-32 pb-24 lg:pt-40 lg:pb-32 bg-ivory overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-warm-white/50 to-ivory"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16 items-center">
          {/* Left Column - 60% */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="lg:col-span-3"
          >
            <p className="font-inter text-xs uppercase tracking-widest text-taupe mb-6">
              Boutique Digital & PMO Consulting
            </p>
            
            <h2 className="font-playfair text-5xl lg:text-7xl font-semibold text-charcoal leading-tight mb-8">
              Strategic Leadership.<br />
              <em className="text-warm-gold">Elevated</em> Execution.<br />
              Measurable Results.
            </h2>
            
            <p className="font-inter text-lg text-charcoal/60 max-w-2xl mb-10 leading-relaxed">
              Enterprise-grade consulting for digital transformation, program leadership, and operational excellence.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-5">
              <Link
                to="/book-consultation"
                className="inline-flex items-center justify-center bg-warm-gold text-charcoal font-inter font-semibold px-8 py-4 rounded-full hover:bg-soft-bronze transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Book a Consultation
              </Link>
              <Link
                to="/services"
                className="inline-flex items-center justify-center border-2 border-charcoal text-charcoal font-inter font-semibold px-8 py-4 rounded-full hover:bg-charcoal hover:text-warm-white transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Explore Services
              </Link>
            </div>
          </motion.div>
          
          {/* Right Column - 40% */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut', delay: 0.2 }}
            className="lg:col-span-2"
          >
            <div className="relative rounded-3xl overflow-hidden bg-muted-taupe p-6 h-96 lg:h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/0a8462a245777ce608ae332ceb6c5c15.jpg"
                alt="Professional consulting workspace"
                className="w-full h-full object-cover object-top rounded-2xl"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
